import styled from 'styled-components';
import { Layout } from 'antd';
import { theme } from 'consts/theme';

export const StyledFooter = styled(Layout.Footer)`
  background-color: ${theme.colors.white};
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 5px 15px 15px 15px;
`;
